import { User } from '@modules/auth/hooks/types'

export const getEventDefaultInfo = (user?: User | null, location?: string) => {
  return {
    visitor_id: user?.id,
    account_id: user?.companyId,
    timestamp: Date.now().toString(),
    device: window.navigator.userAgentData?.platform,
    browser: window.navigator.userAgent,
    is_mobile: window.navigator.userAgentData?.mobile,
    location,
  }
}
